import {createAction} from '@reduxjs/toolkit';

const CLEAN_COUNTS = 'CLEAN_COUNTS';

export const cleanCounts = createAction(CLEAN_COUNTS);
